import React, {useEffect, useState  } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import WelcomeImg from "../../_assets/_images/welcomeImg@2x.png";
import { useDispatch} from 'react-redux'
import {
  setBreadcrumb,
  setBreadcrumbSearch
} from '../../_redux/_actions/breadcrumbAction'
import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
import { useLogin } from "../../config/useLogin.js";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: 75,
    margin: "auto",
    maxWidth: 993,
  },
  image: {
    maxWidth: 325,
    display: "block",
    margin: "auto",
  },
  title: {
    textAlign: "left",
    fontSize: 34,
    letterSpacing: 0,
    color: "#000000",
    opacity: 1,
    marginBottom: 30,
  },
  para: {
    textAlign: "left",
    fontSize: 14,
    letterSpacing: 0,
    color: "#272727",
    opacity: 1,
    marginBottom: 30,
  },
  listItem: {
    textAlign: "left",
    fontSize: 14,
    letterSpacing: 0,
    color: "#272727",
    opacity: 1,
    marginBottom: 18,
    listStyle: "disc",
  },
  ul: {
    marginLeft: 12,
  },
}));

export default function Welcome() {
  const classes = useStyles();
  const dispatch = useDispatch()
  const { instance, accounts } = useMsal();
  const { login } = useLogin();

  const onBreadcrumbClick = () =>{
    var pathArray = window.location.pathname.split("/") ;
    if(window.location.search){
      pathArray[pathArray.length-1]= pathArray[pathArray.length-1]
    }
    dispatch(setBreadcrumb(pathArray))
    let searchArray =[]
    if(window.location.search){
    dispatch(setBreadcrumbSearch(window.location.search.split('&')))
    }
  }

  useEffect(() => {
    const initializeLogin = async () => {
      if (instance && accounts.length === 0) {
        login();
      }
    };
    initializeLogin();
  }, []);

  return (
    <>
      <AuthenticatedTemplate>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ height: "100%" }}
        >
          <Grid item>
            <div className={classes.root}>
              <Paper className={classes.paper}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md>
                    <img
                      src={WelcomeImg}
                      alt="WelcomeImg"
                      className={classes.image}
                    />
                  </Grid>
                  <Grid item xs={12} md>
                    <h4 className={classes.title}>Anomaly Configuration UI</h4>
                    <p className={classes.para}>
                      Anomaly Configuration UI panel can be used to create or
                      configure a finding rule. Scoped Finding rules, within a scope
                      can also be configured
                    </p>
                    <ul className={classes.ul}>
                      <li className={classes.listItem}>
                        Create or Search a Finding Rule
                      </li>
                      <li className={classes.listItem}>Set Scope</li>
                      <li className={classes.listItem}>Configure Anomalies</li>
                      <li className={classes.listItem}>
                        Set Ranked Recommendation
                      </li>
                    </ul>
                      <a href="/rules" className="btn-primary"style={{
                        marginLeft: 0,
                        minWidth: 128,
                        fontFamily: "NotoSansRegular, Helvetica, sans serif",
                        fontSize: 14.31,
                        letterSpacing: 1.25,
                        padding: "6px 16px",
                        height: 37,
                        display: "inline-block",
                        lineHeight: 1.75,
                      }}>
                        GET STARTED
                      </a>
                  </Grid>
                </Grid>
              </Paper>
            </div>
          </Grid>
        </Grid>
      </AuthenticatedTemplate>
    </>
  );
}
